import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { PublicClientApplication } from '@azure/msal-browser';
//import { MsalProvider } from '@azure/msal-react';
//import { msalConfig } from './authConfig';

//const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));

/**
 * We recommend wrapping most or all of your components in the MsalProvider component. It's best to render the MsalProvider as close to the root as possible.
 */
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals();
